import ExchangeOffice from 'components/common/exchange-office.class';
import { offerGroupToCars } from 'src/cars/car-tools';
import { CarOffer } from 'src/cars/types';
import { RawOffer } from 'src/cars/types/raw-offer.type';
import { mergeCarsWithStations, normalizeStations } from 'src/stations/station-tools';
import { base64ToArrayBuffer } from 'src/utils/data-conversion';
import { CurrencyRate } from 'types/currency-rate.type';
import pako from 'pako';
import { RawStation, Station } from 'src/stations/types';
import { FiltersRange, PartnerApiResponse } from './types';

export const processRawData = (
  rawOffers: Array<RawOffer>,
  rawStations: Array<RawStation>,
  rentDays: number,
  sessionId: string,
  exchangeRates?: CurrencyRate,
  jsonFeedOffersRequest = false
): { offers: Array<CarOffer>; stations: Array<Station> } => {
  const ExOffice = new ExchangeOffice(exchangeRates);
  const stations = normalizeStations(rawStations || []);
  const offers: Array<CarOffer> = [];
  (rawOffers || []).forEach((rawOffer: any) => {
    offerGroupToCars(rawOffer, rentDays, stations, jsonFeedOffersRequest).forEach((car) => {
      const agentCurrency = ExOffice.getAgentCurrency();
      if (car.charges.length > 0) {
        car.charges.forEach((fee) => {
          if (fee.included === false && fee.required === true) {
            if (fee.price > 0) {
              if (!fee.currency || fee.currency === car.currency) {
                car.price += fee.price;
              } else {
                car.price += ExOffice.exchange(fee.price, fee.currency, car.currency);
              }
            }
          }
        });
      }

      if (car.deposit && car.depositCurrency && car.depositCurrency !== agentCurrency) {
        car.depositExchanged = ExOffice.getPriceInAgentCurrency(car.deposit, car.depositCurrency);
      }

      if (car.deposit && car.depositCurrency !== 'EUR') {
        car.depositInEUR = ExOffice.getPriceInEur(
          car.deposit,
          car.depositCurrency || agentCurrency
        );
      } else {
        car.depositInEUR = car.deposit;
      }

      const priceExchanged = ExOffice.getPriceInAgentCurrency(car.price, car.currency);
      car.priceExchanged = priceExchanged;
      car.pricePerDay = car.price / rentDays;
      car.pricePerDayExchanged = priceExchanged / rentDays;
      car.currencyExchanged = ExOffice.getAgentCurrency();
      car.priceSort = car.priceExchanged || car.price;
      car.sessionId = sessionId;

      offers.push(car);
    });
  });

  // if (jsonFeedOffersRequest !== true) {
  mergeCarsWithStations(stations, offers);
  // }

  return {
    offers,
    stations: stations.filter((el) => el.cars.length > 0)
  };
};

export const unzipPartnerResponse = (
  data: string | PartnerApiResponse,
  compression = true
): { json: PartnerApiResponse; raw: any } => {
  if (!compression) {
    return {
      json: data as PartnerApiResponse,
      raw: data
    };
  }

  try {
    const arrayBuffer = base64ToArrayBuffer(data);
    const buffer = Buffer.from(arrayBuffer);
    const result = pako.inflate(buffer);

    return {
      json: JSON.parse(Buffer.from(result).toString('utf8')),
      raw: buffer.toString('base64')
    };
  } catch (error) {
    return { json: null, raw: data };
  }
};

export const createFiltersRange = (offers: Array<CarOffer> = []): FiltersRange => {
  const range: FiltersRange = {
    price: { min: 0, max: 0 },
    partners: []
  };

  offers.forEach((car) => {
    if (car.priceSort > range.price.max) {
      range.price.max = car.priceSort;
    }
    if (range.partners.indexOf(car.partner) === -1) {
      range.partners.push(car.partner);
    }
  });

  return range;
};
